import React, { useState, useRef } from "react";
import TextField from "@material-ui/core/TextField";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Button from "@material-ui/core/Button";
import { useHistory, useParams, useLocation } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useSnackbar } from "notistack";

import {
  auth,
  firestore,
  firefunctions,
} from "../../../components/firebase/FirebaseProvider";
import useCountDownTimer from "../../../components/useCountDownTimer/index.js";
import ImageGelombang from "../../../assets/images/login-gelombang.svg";
import ImagePayung from "../../../assets/images/payung.svg";
import Navbar from "../../../components/molecules/navbarLogReg";
import ImageFamily from "../../../assets/images/family.svg";
import useStyles from "./style";

function KirimUlang({ expired_at, requestOTP, loading, setForm }) {
  const { timerArray, seconds } = useCountDownTimer(expired_at);
  const { enqueueSnackbar } = useSnackbar();
  const reRequestOTP = async () => {
    setForm({});
    await requestOTP();
    enqueueSnackbar("6  digit kode baru berhasil dikirim ulang!", {
      variant: "success",
    });
  };
  // console.log(seconds)
  return (
    <Button
      style={{ color: "#5675D3", fontSize: 12, backgroundColor: "#fff" }}
      disabled={seconds > 0}
      onClick={reRequestOTP}
    >
      {seconds > 0
        ? `Kirim Ulang (${timerArray[1]}:${timerArray[2]})`
        : "Kirim Ulang"}
    </Button>
  );
}

export default function Otp() {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("tablet"));
  const matches1 = useMediaQuery(theme.breakpoints.up("lg"));
  const matches2 = useMediaQuery(theme.breakpoints.up("951"));
  const matches3 = useMediaQuery(theme.breakpoints.up("1155"));
  const [year] = useState(new Date().getFullYear());
  const history = useHistory();
  const { phone, timeOTP } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const { search } = useLocation();
  let params = new URLSearchParams(search);
  let source_link = params.get('source_link');
  // const [otosumbit, setOtoSubmit] = useState(true)

  //privateRoute Register
  // automatical focus input
  let sec = useRef(null);
  let three = useRef(null);
  let four = useRef(null);
  let five = useRef(null);
  let six = useRef(null);

  // console.log(phone)
  const requestOTP = async () => {
    // console.log('button clicked sendOtp')
    // setOtoSubmit(false)
    setLoading(true);
    try {
      const callSendOTP = firefunctions.httpsCallable("sendOTP");
      const response = await callSendOTP({ no_hp: phone });

      // console.log(response?.data);
      setLoading(false);

      let expired_at = Date.now() + 5 * 60 * 1000;
      history.push(`/register/otp/${phone}/${expired_at}${source_link === null ? "" : `?source_link=${source_link}`}`);
    } catch (error) {
      // console.log(error.message);
      setLoading(false);
      setError(error.message);
    }
  };

  const handleChange = (name, next) => (values) => {
    // console.log('ini data', values.target.value)
    setForm({ ...form, [name]: values.target.value });
    setErrors({ ...errors, [name]: "" });

    // auto fovus logic
    if (values.target.value >= 1) {
      next.current.focus();
    }
  };

  const validate = async () => {
    let newErrors = {};
    if (!form.satu) {
      newErrors.satu = "OTP wajib Diisi";
    }
    if (!form.dua) {
      newErrors.dua = "OTP wajib Diisi";
    }
    if (!form.tiga) {
      newErrors.tiga = "OTP wajib Diisi";
    }
    if (!form.empat) {
      newErrors.empat = "OTP wajib Diisi";
    }
    if (!form.lima) {
      newErrors.lima = "OTP wajib Diisi";
    }
    if (!form.enam) {
      newErrors.enam = "OTP wajib Diisi";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // setOtoSubmit(false)
    const findErrors = await validate();

    setLoading(true);
    if (Object.values(findErrors).some((message) => message !== "")) {
      setErrors(findErrors);
      setLoading(false);
    } else {
      try {
        const kodeOtp = [
          form.satu,
          form.dua,
          form.tiga,
          form.empat,
          form.lima,
          form.enam,
        ].join("");
        const callVerifydOTP = firefunctions.httpsCallable("verifyOTP");

        const response = await callVerifydOTP({ no_hp: phone, otp: kodeOtp });
        // console.log('succes', response)
        await auth.signInWithCustomToken(
          response?.data?.custom_token ?? "token"
        );

        // if have a data push to screen katalog
        const profilRef = await firestore
          .doc(`users/${response.data.uid}`)
          .get();
        if (profilRef?.data()) {
          // console.log(profilRef?.data().kode_referral)

          // sudah pernah melakukan registerasi
          if (profilRef?.data().alamat_utama) {
            return history.replace(`/`);
          }

          // pending pembayaran
          if (profilRef?.data().kode_referral) {
            return history.replace(`/register/pembayaran`);
          }
        } else {
          // send with uid because the screen form not children
          history.replace(`/register/form${source_link === null ? "" : `?source_link=${source_link}`}`);
          return enqueueSnackbar("Silahkan isi form berikut ini", {
            variant: "success",
          });
        }
      } catch (error) {
        // console.log(error.message)
        setError(error.message);
        setLoading(false);
      }
    }
  };

  // auto submit if panjang 6 dan otoSubmit true
  // if (Object.keys(form).length === 6 && otosumbit) {
  //     setOtoSubmit(false)
  //     handleSubmit()
  // }

  return (
    <div>
      <div className={classes.header}>
        <Navbar />
        <div>
          {matches ? (
            <>
              {matches1 ? (
                <div className={classes.divPayung}>
                  <img
                    src={ImagePayung}
                    alt="Payung"
                    className={classes.payung}
                  />
                </div>
              ) : null}
              <div>
                <img
                  src={ImageGelombang}
                  alt="Gelombang"
                  className={classes.gelombang}
                />
              </div>
              {matches2 ? (
                <div
                  style={{
                    margin: "5%",
                    marginLeft: "10%",
                  }}
                >
                  <img
                    src={ImageFamily}
                    alt="Family"
                    style={{ width: "30%", position: "absolute" }}
                  />
                </div>
              ) : null}
            </>
          ) : null}
          <div>
            <div className={classes.content}>
              <div className={classes.boxContent}>
                <h1 className={classes.textContent}>Selamat Datang!</h1>
                <div className={classes.textContent3}>
                  <h4 className={classes.textContent3H4}>
                    Masukkan 6-digit code yang telah <br /> dikirimkan ke nomor{" "}
                    {phone}
                  </h4>
                </div>
                <div className={classes.garisContent} />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignSelf: "center",
                  }}
                >
                  <form
                    noValidate
                    autoComplete="off"
                    onSubmit={handleSubmit}
                    style={{ width: matches ? "90%" : "94%" }}
                  >
                    <TextField
                      id="outlined-size-small"
                      autoFocus={true}
                      value={form.satu}
                      error={errors ? errors.satu : false}
                      onChange={handleChange("satu", sec)}
                      onFocus={(e) => e.target.select()}
                      variant="outlined"
                      size={matches ? `small` : null}
                      className={classes.form}
                      inputProps={{
                        style: { textAlign: "center", fontSize: 18 },
                        maxLength: 1,
                      }}
                    />
                    <TextField
                      id="outlined-size-small"
                      value={form.dua}
                      error={errors ? errors.dua : false}
                      onChange={handleChange("dua", three)}
                      onFocus={(e) => e.target.select()}
                      variant="outlined"
                      size={matches ? `small` : null}
                      className={classes.form}
                      inputProps={{
                        style: { textAlign: "center", fontSize: 18 },
                        maxLength: 1,
                      }}
                      inputRef={sec}
                    />
                    <TextField
                      id="outlined-size-small"
                      value={form.tiga}
                      error={errors ? errors.tiga : false}
                      onChange={handleChange("tiga", four)}
                      onFocus={(e) => e.target.select()}
                      variant="outlined"
                      size={matches ? `small` : null}
                      className={classes.form}
                      inputProps={{
                        style: { textAlign: "center", fontSize: 18 },
                        maxLength: 1,
                      }}
                      inputRef={three}
                    />
                    <TextField
                      id="outlined-size-small"
                      value={form.empat}
                      error={errors ? errors.empat : false}
                      onChange={handleChange("empat", five)}
                      onFocus={(e) => e.target.select()}
                      variant="outlined"
                      size={matches ? `small` : null}
                      className={classes.form}
                      inputProps={{
                        style: { textAlign: "center", fontSize: 18 },
                        maxLength: 1,
                      }}
                      inputRef={four}
                    />
                    <TextField
                      id="outlined-size-small"
                      value={form.lima}
                      error={errors ? errors.lima : false}
                      onChange={handleChange("lima", six)}
                      onFocus={(e) => e.target.select()}
                      variant="outlined"
                      size={matches ? `small` : null}
                      className={classes.form}
                      inputProps={{
                        style: { textAlign: "center", fontSize: 18 },
                        maxLength: 1,
                      }}
                      inputRef={five}
                    />
                    <TextField
                      id="outlined-size-small"
                      value={form.enam}
                      error={errors ? errors.enam : false}
                      onChange={handleChange("enam", six)}
                      onFocus={(e) => e.target.select()}
                      variant="outlined"
                      size={matches ? `small` : null}
                      className={classes.form}
                      inputProps={{
                        style: { textAlign: "center", fontSize: 18 },
                        maxLength: 1,
                      }}
                      inputRef={six}
                    />
                    <div>
                      {error ? (
                        <span style={{ fontSize: 9, color: "red" }}>
                          {error}
                        </span>
                      ) : null}
                    </div>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.formBottom}
                      disabled={loading}
                    >
                      {loading === true ? (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      ) : (
                        "Kirim "
                      )}
                    </Button>
                  </form>
                </div>
                <h5
                  style={{ color: "#00000040", fontSize: matches1 ? 11 : 12 }}
                >
                  Tidak mendapatkan kode?
                  <KirimUlang
                    loading={timeOTP}
                    expired_at={timeOTP}
                    requestOTP={requestOTP}
                    setForm={setForm}
                  />
                </h5>
              </div>
            </div>
            <div className={classes.textCopyright}>
              {matches3 ? (
                <h5 className={classes.textCopyrightH5}>
                  Copyright © TokoRame {year}
                </h5>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
